<div class="congratulation-container">
  <h1 class="congratulation-title">{{ 'Sellers.Products.Success' | translate }}!</h1>
  <div class="congratulation-row">
    <p>
      {{ 'Sellers.Products.SavedChanges' | translate }}
    </p>
    <div>
      {{ 'Sellers.Products.ProductLink' | translate }}
      <div class="referralLink" (click)="copyInputMessage(data.url)">
        {{data.url}}
        <button matSuffix mat-icon-button aria-label="copy to clipboard">
          <mat-icon style="color: #455268;">content_copy</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="congratulation-row congratulation-share">
    <p>{{ 'Sellers.Products.Share' | translate }} {{ data.name }} {{ 'Sellers.Products.ToYourCustomers' | translate }}:</p>
    <app-share [url]="data.url"></app-share>
  </div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-primary col-auto" (click)="goToProductManagement()">
      {{ 'Sellers.Products.BackToManagement' | translate }}
    </button>
  </div>
</div>
